import { Machines } from '../datamodels';

export const MACHINE_FALLBACK_IMAGE = '/assets/pl_icon/icon_f_matt.png';

export const getMachineImageUrl = (
  machine?: Pick<Machines, 'imagePath' | 'image'> | null
): string => {
  const localPath = machine?.imagePath?.trim();
  if (localPath) return localPath;

  const legacyImage = machine?.image as
    | { downloadURL?: string }
    | { downloadURL?: string }[]
    | undefined;

  if (Array.isArray(legacyImage)) {
    return legacyImage[0]?.downloadURL || MACHINE_FALLBACK_IMAGE;
  }

  return legacyImage?.downloadURL || MACHINE_FALLBACK_IMAGE;
};
